import React from 'react';

import blocco_img_fse from "../../../../assets/img/blocco_img_fse.png";
import logo_por from "../../../../assets/img/logo_por.png";

const Images = () => {
    return (
        <section className="shadow bg-white row justify-content-between align-items-center flex-wrap" style={{position: 'relative', zIndex: '-1'}}>
            <div className="col-5">
                <img src={logo_por} width="200"
                     alt="loghi POR"/>
            </div>
            <div className="col-7 text-right">
                <img width="800" src={blocco_img_fse} alt="loghi Regione Toscana" className="img-fluid"/>
            </div>
        </section>
    )
};


export default Images;
